import { throwError as observableThrowError, Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';

/**
 * Injection token to allow the Google Maps API key to be injected by the Angular DI
 */
export const GOOGLE_MAPS_API_KEY = new InjectionToken<string>('GOOGLE_MAPS_API_KEY');

/**
 * URL of Google's geocode service
 */
const GOOGLE_GEOCODE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

/**
 * Address paramaters supported by the service
 */
export interface Address {
  address1?: string;
  address2?: string;
  town?: string;
  state?: string;
  postcode?: string;
  country?: string;
}

@Injectable()
export class GoogleGeocodeService {
  constructor(@Inject(GOOGLE_MAPS_API_KEY) private apiKey, private http: HttpClient) {}

  public requestLocation(address: Address): Observable<any> {
    const params = new HttpParams()
      .append('key', this.apiKey)
      .append('address', this.getAddressString(address));
    return this.http.get(GOOGLE_GEOCODE_URL, { params: params }).pipe(
      map((response: any) => {
        if (!response.results || response.results.length === 0) {
          throw new Error('no results found');
        }
        return response.results[0].geometry.location;
      })
    );
  }

  public getAddressString(address: Address) {
    return Object.getOwnPropertyNames(address)
      .filter(prop => address[prop])
      .map(prop => address[prop])
      .join(' ');
  }
}
